module.exports = __webpack_public_path__ + "img/8-Look_Man2.dbd5b29.png";